import DownloadSettingsContainer from './containers/DownloadSettingsContainer'

export default DownloadSettingsContainer
